import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import GenericSelect from '../../../components/ui/GenericSelect';
import { fetchPoolOptions } from '../config/poolApi';

// Başvuru reddet/diskalifiye diyaloğundaki OPSİYONEL "Aday Havuzuna Ekle" seçicisi.
// Seçilirse durum isteğinin gövdesine `addToPoolId` eklenir (SPEC F2); boş = havuza
// ekleme yok. Yalnız AT.Write'a çizilir (havuzlar tüm adayları içerir) — çağıran
// görünürlüğü kendisi karar verir, bileşen yalnız listeyi yükler.
const Hint = styled.p`
  margin: 4px 0 0;
  font-size: 11px;
  color: ${({ theme }) => theme.colors.text.dark.little};
`;

export default function PoolSelectField({ value, onChange }) {
  const { t } = useTranslation();
  const [pools, setPools] = useState([]);

  useEffect(() => {
    let alive = true;
    fetchPoolOptions().then(({ items }) => { if (alive) setPools(items); });
    return () => { alive = false; };
  }, []);

  return (
    <div data-role="ats-status-pool-select">
      <GenericSelect
        label={t('ats.candidatePool.addToPoolOptional')}
        options={pools}
        value={value || null}
        onChange={(v) => onChange(v || '')}
        placeholder={t('ats.candidatePool.noPoolSelected')}
        idKey="id"
        labelKey="name"
      />
      <Hint>{t('ats.candidatePool.addToPoolOptionalHint')}</Hint>
    </div>
  );
}

// Reddet/diskalifiye gibi başvuruyu KAPATAN aksiyonlar — havuz yalnız bunlarda sunulur.
export const POOL_ELIGIBLE_ACTIONS = ['disqualify', 'reject'];
